<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="board"
      :is-print="isPrint"/>

    <!-- 구분 -->
    <vs-row class="mt-28px mb-6">
      <vs-col><h5><i class="dot"></i>구분</h5></vs-col>
    </vs-row>
    <div :class="{'gap-x-4 flex': isPrint, 'grid': !isPrint}"
         :style="isPrint ? '' : 'grid-template-columns: repeat(5, 1fr)'">
      <div v-for="(item, itemIndex) in 구분리스트">
        <PrintRadio v-if="isPrint" :label="item.label" :value="item.value === form.구분" class="justify-center" />
        <vs-radio v-else vs-name="구분" :vs-value="item.value" v-model="form.구분" class="mr-2">
          <span class="whitespace-no-wrap">{{item.label}}</span>
        </vs-radio>
      </div>
    </div>

    <!-- 선임대상 정보-->
    <write-grid-container class="mt-28px" title="선임대상 정보" v-model="form.subInfo" :options="gridContainerOptions">
      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint" class="printing">
          <div v-if="dataType === 'blank'"></div>
          <div v-else-if="dataType === 'file'" class="print-input w-full">{{ form.subInfo[value].fileName }}</div>
          <div class="print-input w-full" v-else>{{ form.subInfo[value] }}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <date-selector v-if="dataType === 'date'" class="w-full" v-model="form.subInfo[value]" />
          <div v-else-if="dataType === 'blank'"></div>
          <file-uploader v-else-if="dataType === 'file'" class="w-full" v-model="form.subInfo[value]" />
          <ml-input v-else-if="dataType === 'text'" class="w-full" v-model="form.subInfo[value]" readonly />
          <ml-input v-else class="w-full" v-model="form.subInfo[value]" />
        </div>
      </template>
    </write-grid-container>

    <!-- 파일첨부 -->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-8" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import WriteGridContainer from "@/components/WriteGridContainer.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import DateSelectorRang from "@/components/selector/DateSelectorRang.vue";
import RadioGroup from "@/components/radio/RadioGroup.vue";
import FileUploader from "@/components/FileUploader.vue";
import PrintRadio from "@/components/print/PrintRadio.vue";

export default {
  components: {
    PrintRadio,
    FileUploader,
    RadioGroup,
    DateSelectorRang,
    DateSelector,
    WriteGridContainer,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
  },
  data() {
    return {
      gridContainerOptions: {
        dataTypes: ["text", "string", "string", "date", "date", "date", "file"],
        labels: ["법령", "이름", "사번", "선임일", "최근 교육일", "차기 교육일", "교육이수증"],
        values: ["법령", "이름", "사번", "선임일", "최근교육일", "차기교육일", "교육이수증"],
      },

      구분리스트: [
        { label: '통합환경총괄관리인', value: '통합환경총괄관리인'},
        { label: '통합환경일반관리인', value: '통합환경일반관리인'},
        { label: '폐기물관리인', value: '폐기물관리인'},
      ],

      form: {
        stdInfo: {},
        fileList: [],
        subInfo: {},
        구분: "",
      },
    };
  },
  computed: {
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    // subInfo 초기화
    this.form.subInfo = this.gridContainerOptions.values.reduce((acc, cur) => {
      acc[cur] = cur === '법령' ? '환경오염시설의통합관리에관한법률' : ''; // 법령 고정
      return acc;
    }, {})

    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {

  }
};
</script>
<style lang="scss" scoped>
</style>
